import { render, staticRenderFns } from "./FilteredTags.vue?vue&type=template&id=cefa5308"
import script from "./FilteredTags.vue?vue&type=script&lang=js"
export * from "./FilteredTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports